import { showFailureToast, showSuccessToast } from "@helpers";
import { createAction, createSlice } from "@reduxjs/toolkit";

const addCourseToCartSlice = createSlice({
  name: "addCourseToCart",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state) {
      state.processing = false;
      showSuccessToast("Add course to cart successful!");
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      if (action.payload.message) {
        showFailureToast(action.payload.message);
      } else {
        showFailureToast("Add course to cart failure!");
      }
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = addCourseToCartSlice;
const addCourseToCartAction = createAction(name);

export {
  addCourseToCartAction,
  actions as addCourseToCartActions,
  reducer as addCourseToCartReducer,
};
